import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App"; // Import useAuth hook
import ButtonWithIcon from "../Components/ButtonwithIcon/ButtonWithIcon";
import ColoredCheckbox from "../Components/ColoredCheckbox/ColoredCheckbox";
import logo from "../Images/CompanyLogo.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./Login.scss";

export default function SignIn() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const navigate = useNavigate();
  const { login, loading } = useAuth(); // Use auth context

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!username || !password) {
      setError("Username and Password are required");
      return;
    }

    // Clear previous errors
    setError("");

    try {
      // Use the login function from auth context
      const result = await login({
        username,
        password,
        rememberMe,
      });

      if (result.success) {
        navigate("/home");
      } else {
        setError(result.error);
      }
    } catch (error) {
      console.error("Login error:", error);
      setError("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <div className="header">
          <div className="login-logo">
            <img src={logo} alt="Logo" />
          </div>
        </div>
        <h1 className="title">Log In</h1>
        <form noValidate onSubmit={handleSubmit} className="login-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="username" className="login-label">
                Email
              </label>
              <input
                type="text"
                id="username"
                className="form-input"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={loading}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password" className="login-label">
                Password
              </label>
              <div className="password-input-container">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-input"
                  disabled={loading}
                />
                <button
                  type="button"
                  className="password-button"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                >
                  {showPassword ? (
                    <FaEyeSlash fill="black" stroke="black" />
                  ) : (
                    <FaEye fill="black" stroke="black" />
                  )}
                </button>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="checkbox-group">
              <ColoredCheckbox
                label="Remember this Device"
                color="primary"
                name="remember"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                disabled={loading}
              />
            </div>
          </div>
          <div className="form-group">
            {error && <div className="error-message">{error}</div>}
            <ButtonWithIcon
              type="submit"
              className="submit-button"
              text={loading ? "Logging in..." : "Login"}
              disabled={loading}
            />
          </div>
        </form>
      </div>
      <div className="welcome-section">
        <h1 className="welcome-title">Welcome to OurDept</h1>
        <p className="welcome-description">
          OurDept helps developers build organized and well-coded dashboards
          full of beautiful and rich modules.
        </p>
        <ButtonWithIcon className="learn-more-button" text="Learn More" />
      </div>
    </div>
  );
}
